<div class="modal-header align-items-center">
  <div class="col">
    <h4 class="modal-title" translate>Edit form</h4>
  </div>
  <div class="col-auto">
    <button (click)="onClose()" aria-label="Close" class="close" type="button">
      <span aria-hidden="true" class="fa-solid fa-xmark"></span>
    </button>
  </div>
</div>
<div class="modal-body">
  <form [formGroup]="editForm">
    <div class="form-group">
      <label>
        <span translate>BigQuery Table</span>
        <em [ngbTooltip]="'This field cannot be changed after saving.'|translate"
          class="fa-solid fa-circle-question text-muted ml-1"
        placement="top"></em>
        <scitis-required-field-indicator></scitis-required-field-indicator>
      </label>
      @if (isLoadingTableName) {
        <span class="fa-solid fa-gear fa-spin"></span>
      }
      <div class="input-group mb-3">
        <input #bigQueryNameInput [attr.disabled]="disableBigQueryNameInput? true: null"
          [ngClass]="getTableNameClass()"
          [placeholder]="'Enter table name...'|translate"
          (input)="disableFormWhileTyping()"
          (change)="validateTableName(bigQueryNameInput.value)"
          class="form-control" formControlName="bigQueryTableName" type="text">
          <div class="input-group-append">
          </div>
          @if (formControls.bigQueryTableName.errors) {
            <div class="invalid-feedback">
              @if (formControls.bigQueryTableName.errors.reservedWord) {
                <span
                translate>Invalid name: name is a reserved word.</span>
              }
              @if (formControls.bigQueryTableName.errors.required) {
                <span
                translate>BigQuery Table name is required.</span>
              }
              @if (formControls.bigQueryTableName.errors.bigQueryValidName && !formControls.bigQueryTableName.errors.required) {
                <span
                translate>BigQuery Table name can only contain letters, numbers and underscore and can only begin with a letter or underscore.</span>
              }
            </div>
          }
          @if (tableNameIsFree === false) {
            <div class="invalid-feedback" translate>Table name already used!</div>
          }
        </div>
      </div>
    </form>
    <h3 class="h6 mb-2" translate>Form fields</h3>
    <div [(dragulaModel)]="formPageConfiguration.inputFields" [dragula]="dragAndDropInputFieldItems">
      @for (currentInputField of formPageConfiguration.inputFields; track currentInputField) {
        <div class="mb-2">
          <div class="list-group-item edit-menu-item edit-menu-item-active">
            <div class="row edit-menu-header">
              <div (click)="collapse.toggle()" [attr.aria-expanded]="!currentInputField.isCollapsed" class="col">
                <span class="fa-solid fa-grip-vertical mr-2 text-muted"></span>
                <div class="edit-menu-item-icon">
                  <span [ngClass]="getItemTypeClass(currentInputField)"></span>
                </div>
                <span>
                  <span translate>Input Field:</span>
                  <span [innerHTML]="currentInputField.label"></span>
                  @if (!currentInputField.isValidConfiguration) {
                    <span class="text-danger ml-1"><em class="fa-solid fa-circle-exclamation"></em></span>
                  }
                </span>
              </div>
              <div class="col-auto">
                <div class="edit-menu-item-functions">
                  <div class="d-inline-flex" ngbDropdown>
                    <button class="btn btn-xs btn-outline-primary dropdown-no-arrow" id="dropdownBasic2" ngbDropdownToggle>
                      <span class="fa-solid fa-ellipsis-vertical"></span>
                    </button>
                    <div ngbDropdownMenu>
                      <button (click)="collapse.toggle()" ngbDropdownItem>
                        <span class="fa-solid fa-pen"></span>
                        <span translate>Edit field</span>
                      </button>
                      <button (click)="onDeleteInputField(currentInputField)" class="text-danger" ngbDropdownItem>
                        <span class="fa-solid fa-trash"></span>
                        <span translate>Delete field</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div #collapse="ngbCollapse" [ngbCollapse]="isCollapsed(currentInputField.isCollapsed)">
            <scitis-form-page-input-field
              (formIsValid)="onCheckFormsValidation($event)"
              [inputField]="currentInputField"
              [inputFields]="formPageConfiguration.inputFields"
              [subFormValidityTrigger]="subFormValidityTrigger">
            </scitis-form-page-input-field>
          </div>
        </div>
      }
    </div>

    <button (click)="addField()" class="btn btn-outline-primary mr-2">
      <span class="fa-solid fa-plus"></span>
      <span translate>Add field</span>
    </button>
  </div>
  <scitis-modal-footer (cancelButtonPressed)="onCancel($event)"
    (okButtonPressed)="onSave()"
    [cancelButtonText]="'Cancel'|translate"
    [disableOkButton]="disableSaveButton()"
    [okButtonText]="'Save'|translate"
    [showRequiredFieldsIndicator]="true">
  </scitis-modal-footer>
